import { getOwner } from '@ember/owner';
import Component from '@glimmer/component';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import { t } from 'ember-intl';
import Countries from 'frontend-utils/utils/countries';
import GeneralCountryFlag from 'lumen/components/general/country-flag';

interface ParityTablesCellsTdPosCountrySignature {
  Args: {
    cellData: unknown;
  };
}

export default class ParityTablesCellsTdPosCountry extends Component<ParityTablesCellsTdPosCountrySignature> {
  // @ts-expect-error: Incorrect type
  countries = new Countries(getOwner(this));

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get countryCode() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return this.args.cellData?.toLowerCase() || null;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get countryName() {
    if (this.args.cellData) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-call
      return this.countries.getName(this.args.cellData.toUpperCase());
    }

    return null;
  }

  <template>
    <div class="flex items-center justify-center">
      {{#if this.countryCode}}
        <GeneralCountryFlag @countryCode={{this.countryCode}} @size="medium" />
        {{#if this.countryName}}
          <EmberTooltip @side="right" @tooltipClass="default-tooltip">
            {{this.countryName}}
          </EmberTooltip>
        {{/if}}
      {{else}}
        {{t "general.missing"}}
      {{/if}}
    </div>
  </template>
}
